import { render, staticRenderFns } from "./NotRegisteredWithGP.vue?vue&type=template&id=967870ac&"
import script from "./NotRegisteredWithGP.vue?vue&type=script&lang=js&"
export * from "./NotRegisteredWithGP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports